const controllers = {
  home: require('./views/home'),
  dashboard: require('./views/dashboard'),
  tags: require('./views/tags'),
  tagsIndex: require('./views/tags-index'),
  corporate: require('./views/corporate'),
}

export default controllers
